import styled from "styled-components";
export const HeaderEmphasis = styled.em`
    font-weight: 100;
    margin-left: 0.3rem;
`;
